import React, { useContext, useState, useEffect } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { AddressSearchContext } from '/src/App';
import Confetti from 'react-confetti';
import { WindowSizeContext } from '/src/App';
import './style.css';
const CompeteOverMe = ({
    propertyData,
    userPlanSelection,
    companies,
    projects
}) => {
    const { handleOptInToCompeteOverMe, user } = useContext(AddressSearchContext);
    const { deviceType } = useContext(WindowSizeContext);
    const [showConfetti, setShowConfetti] = useState(false);
    const [windowDimension, setWindowDimension] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [ctaButtonText, setCtaButtonText] = useState("Opt In");
    const [isOptedIn, setIsOptedIn] = useState(false);
    
    // useEffect that monitors user, checks the competeOverMe array, and updates the ctaButtonText
    useEffect(() => {
        if (user?.competeOverMe?.includes(propertyData.address_id)) {
            setCtaButtonText("We're On It!");
            setIsOptedIn(true);
        } else {
            setCtaButtonText("Opt In");
            setIsOptedIn(false);
        }
    }, [user]);

    useEffect(() => {

        // Set up event listener for window resize
        const detectSize = () => {
            setWindowDimension({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener('resize', detectSize);

        // // Set timer for confetti
        // const timer = setTimeout(() => handleConfetti(), 8000);

        // Cleanup function
        return () => {
            window.removeEventListener('resize', detectSize);
            // clearTimeout(timer);
        };
    }, []); // Empty dependency array means this effect runs once on mount

    const handleConfetti = () => {

        setShowConfetti(true);
        setTimeout(() => {
            setShowConfetti(false);
        }, 4000);
    }

    const handleOptIn = () => {
        const propertyId = propertyData?.address_id || null;

        if (!propertyId) {
            return;
        }

        handleConfetti();
        handleOptInToCompeteOverMe(propertyId);
    }


    const steps = [
        {
            icon: "human-focused.png",
            title: "You opt in and give us the go-ahead",
        },
        {
            icon: "broadcast-to-market-icon.png",
            title: "Quoll creates an anonymous profile based on your home improvement plans",
        },
        {
            icon: "companies-competing-icon.png",
            title: "Companies bid to win your high-value business",
        },
        {
            icon: "lounging-icon.png",
            title: "Quoll shares each offer with you, letting you choose the best one",
        }
    ]

    const introSentence = "Even armed with the knowledge of who is offering discounts, we understand that the process can still feel daunting. Companies benefit from you feeling overwhelmed, underinformed, and unable to shop around. It lets them compete on marketing slogans instead of who can actually provide you the best deal."
    const introSentence2 = "Companies are desperate to find resilient homeowners. We can use your home improvement plans to actually drive the sort of competition between them that results in you getting meaningful discounts for your work. Here is how it works:"
    const conclusionSentence = "No spam emails, no marketing lists, and you'll only hear from us when we have something to share. "

    

    const confettiText = "Wooo let's get you some discounts! As promised, you'll only hear from us when we have something to share."

    return (
        <div className="taking-action-section-container">
            <h1>Compete Over Me</h1>
            {showConfetti && (
                <>
                    <Confetti
                        width={windowDimension.width}
                        height={windowDimension.height}
                        recycle={false}
                        numberOfPieces={400}
                    />
                    <p className="compete-over-me-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: confettiText }} />
                </>
            )}
            {!showConfetti && (
                <>
                    <div className="compete-over-me-intro-container">
                        <p className="compete-over-me-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: introSentence }} />
                        <p className="compete-over-me-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: introSentence2 }} />
                    </div>
                    <div className={`compete-over-me-steps-container ${deviceType}`}>
                        {steps.map((step, index) => (
                            <div className="compete-over-me-step" key={index}>
                                <div className="compete-over-me-step-number-container">
                                    <span className="compete-over-me-step-number">Step {index + 1}</span>
                                </div>
                                <div className="compete-over-me-step-icon-container">
                                    <img src={CreateCloudfrontUrl(step.icon)} alt={step.title} />
                                </div>
                                <span className="compete-over-me-step-title text-align-center">{step.title}</span>
                            </div>
                        ))}
                    </div>
                    <p className="compete-over-me-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: conclusionSentence }} />
                    <button
                        className={`compete-over-me-turn-on-button ${isOptedIn ? "opted-in" : ""}`}
                        onClick={isOptedIn ? null : handleOptIn}
                    >
                        {ctaButtonText}
                    </button>
                </>
            )}
        </div>
    );
};

export default CompeteOverMe;